import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sticky-container',
  templateUrl: './sticky-container.component.html',
  styleUrls: ['./sticky-container.component.scss']
})
export class StickyContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
